import { DomainEvent } from 'src/app/core/domain/events/domain_event';

import { Email } from '../../email/email';

export class EmailEvent extends DomainEvent<Email> {}

export class EmailSent extends EmailEvent {}
